import jsQR from 'jsqr';

/**
 * Tenta decodificar QR Code de um File de imagem original (sem compressão).
 * Falha silenciosamente retornando null — não interrompe o fluxo OCR.
 */
export function decodeQRCodeFromFile(file: File): Promise<string | null> {
  if (typeof window !== 'undefined' && (window as any).__MOCK_QR_CODE__ !== undefined) {
    return Promise.resolve((window as any).__MOCK_QR_CODE__);
  }

  return new Promise((resolve) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      if (!ctx) return resolve(null);
      ctx.drawImage(img, 0, 0);
      try {
        const { data, width, height } = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(data, width, height, { inversionAttempts: 'dontInvert' });
        resolve(code ? code.data : null);
      } catch (err) {
        console.error('Erro ao ler pixels para QR:', err);
        resolve(null);
      }
    };
    img.onerror = () => { URL.revokeObjectURL(objectUrl); resolve(null); };
    img.src = objectUrl;
  });
}
